var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJeepHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29462",
    "data-name": "Group 29462",
    transform: "translate(-421.999 -742.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(421.999 742.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jeep",
    transform: "translate(435.79 753.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50593",
    "data-name": "Path 50593",
    d: "M6.5,14v5.763c0,.948-.363,2.9-3.25,2.9S0,20.846,0,19.806v-.932H2.015v.915a1.119,1.119,0,0,0,1.17,1.17,1.1,1.1,0,0,0,1.23-1.154V14Z",
    transform: "translate(0 -14)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50594",
    "data-name": "Path 50594",
    d: "M15.793,23.621c-.625,0-.978-.487-.978-1.371h3.6c0-2.769-1.477-3.25-2.708-3.25C13.492,19,13,20.679,13,22.119a2.709,2.709,0,0,0,2.708,2.838c1.6,0,2.685-1.056,2.685-1.85H16.625A.891.891,0,0,1,15.793,23.621Zm-.1-3.418a.952.952,0,0,1,.958,1.054H14.815C14.815,20.679,15.042,20.2,15.689,20.2Z",
    transform: "translate(-5.959 -16.292)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50595",
    "data-name": "Path 50595",
    d: "M26.793,23.621c-.625,0-.978-.487-.978-1.371h3.6c0-2.769-1.477-3.25-2.708-3.25C24.492,19,24,20.679,24,22.119a2.709,2.709,0,0,0,2.708,2.838c1.6,0,2.685-1.056,2.685-1.85H27.625A.891.891,0,0,1,26.793,23.621Zm-.1-3.418a.952.952,0,0,1,.958,1.054H25.815C25.815,20.679,26.042,20.2,26.689,20.2Z",
    transform: "translate(-11.001 -16.292)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50596",
    "data-name": "Path 50596",
    d: "M39,19a1.939,1.939,0,0,0-1.834.969V19H35v8.125h2.167V24.416a2.12,2.12,0,0,0,1.857.769c1.569,0,2.476-1.35,2.476-3.195C41.5,19.6,39.977,19,39,19Zm-.59,4.81c-.955,0-1.266-.6-1.244-1.752s.541-1.619,1.152-1.619c1,0,1.185.763,1.185,1.552S39.363,23.81,38.41,23.81Z",
    transform: "translate(-16.043 -16.292)",
    fill: "#455a64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeepHighlighted);
export default __webpack_public_path__ + "static/media/jeepHighlighted.66fba5439dd7419f34fb355f9a65c714.svg";
export { ForwardRef as ReactComponent };